import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Şifren güncellendi.");
      setOldPw(""); setNewPw("");
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-950/95 backdrop-blur-xl border-slate-800 text-slate-100 sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Şifre Değiştir</DialogTitle>
          <DialogDescription className="text-slate-400">Mevcut şifreni doğrulayıp yeni şifreni belirle. Şifreni unuttuysan yöneticiye yaz.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="old-password-input" type="password" className="cx-input" placeholder="Mevcut şifre" value={oldPw} onChange={(e) => setOldPw(e.target.value)} required />
          <Input data-testid="new-password-input" type="password" className="cx-input" placeholder="Yeni şifre (en az 4 karakter)" value={newPw} onChange={(e) => setNewPw(e.target.value)} required minLength={4} />
          <Button data-testid="change-password-submit" type="submit" disabled={loading} className="w-full cx-btn-primary rounded-xl h-11">{loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
